import { Api } from '@mopla/data-models';

import { EntityDescriptor } from '../business-logic';
import { TColReplicationDescriptor } from '../ReplicationController';
import {
	IPassengerBookingCheckpoint,
	passengerBookingSchema,
	TPassengerBookingDocType,
} from '../schemas/passengerBooking';

import { passengerBookingPullHandler } from './utils/passengerBookingPullHandler';

export const passengerBookingEntity: EntityDescriptor<TPassengerBookingDocType> =
	{
		passenger_booking: {
			migrationStrategies: {
				1: function (oldDoc) {
					// migration to rxdb 12
					return oldDoc;
				},
				2: function (oldDoc) {
					// remove isPaid and add paymentState instead
					return null;
				},
				3: function (oldDoc) {
					oldDoc.updatedTime = oldDoc.updatedTime ?? new Date().toISOString();
					return null;
				},
				4: function (oldDoc) {
					// migration to rxdb 16
					return oldDoc;
				},
				5: function (oldDoc) {
					// add CANCELLED_BY_DRIVER to bookingStatus enum
					return oldDoc;
				},
				6: function (oldDoc) {
					// added new `usedVoucher` root level field
					return oldDoc;
				},
				7: function (oldDoc) {
					// added `paymentState` root level field
					return oldDoc;
				},
				8: function (oldDoc) {
					// `paymentAmount` fields are now nullable
					return oldDoc;
				},
				9: function (oldDoc) {
					// bookingCode added
					oldDoc.bookingCode = oldDoc.bookingCode ?? '';

					return oldDoc;
				},
				10: function (oldDoc) {
					// added SPECIAL_SCHOOL_TRAFFIC (RMBLS) to the leg.mode enum
					return oldDoc;
				},
				11: function (oldDoc) {
					// added top-level `cancellableUntil`
					return oldDoc;
				},
				12: function (oldDoc) {
					// added `itinerary.stops` and `itinerary.transfers`
					return oldDoc;
				},
				13: function (oldDoc) {
					// price info moved into `leg.payment`, added `*PriceInfoAggregate`
					// root fields; the values arrive with the re-pull, not from here
					return oldDoc;
				},
			},
			schema: passengerBookingSchema,
			//TODO refactor this handler
			// conflictHandler: async (i) => {
			// 	if (i.newDocumentState.updatedTime === i.realMasterState.updatedTime) {
			// 		return {
			// 			isEqual: true,
			// 		};
			// 	}
			//
			// 	return {
			// 		isEqual: false,
			// 		documentData: i.realMasterState,
			// 	};
			// },
		},
	};

export const passengerBookingReplicationDescriptor = (
	api: Api
): TColReplicationDescriptor<
	TPassengerBookingDocType,
	IPassengerBookingCheckpoint
> => ({
	collectionName: 'passenger_booking',
	replicationIdentifier: 'passenger_booking-repl',
	deletedField: 'deleted',
	pull: {
		handler: (checkpointOrUndefined) =>
			passengerBookingPullHandler(api, checkpointOrUndefined),
		batchSize: 25, //This is set in the BE, so we just align with their value
	},
	autoStart: false,
	authOnly: true,
});
